import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisIntegrationSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type HrisIntegrationSidebarQuery = { __typename?: 'Query', HrisIntegration?: { __typename?: 'HrisIntegration', id: string, type: Types.HrisIntegrationType, createdAt: string, hrisProvider?: string | null, initialSyncCompletedAt?: string | null, status?: Types.MergeLinkedAccountStatus | null, statusDetail?: string | null, lastReceivedDataAt?: string | null } | null };


export const HrisIntegrationSidebarDocument = gql`
    query HrisIntegrationSidebar($id: UUID!) {
  HrisIntegration(id: $id) {
    id
    type
    createdAt
    hrisProvider
    initialSyncCompletedAt
    status
    statusDetail
    lastReceivedDataAt
  }
}
    `;

/**
 * __useHrisIntegrationSidebarQuery__
 *
 * To run a query within a React component, call `useHrisIntegrationSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisIntegrationSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisIntegrationSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisIntegrationSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisIntegrationSidebarQuery, HrisIntegrationSidebarQueryVariables> & ({ variables: HrisIntegrationSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisIntegrationSidebarQuery, HrisIntegrationSidebarQueryVariables>(HrisIntegrationSidebarDocument, options);
      }
export function useHrisIntegrationSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisIntegrationSidebarQuery, HrisIntegrationSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisIntegrationSidebarQuery, HrisIntegrationSidebarQueryVariables>(HrisIntegrationSidebarDocument, options);
        }
export type HrisIntegrationSidebarQueryHookResult = ReturnType<typeof useHrisIntegrationSidebarQuery>;
export type HrisIntegrationSidebarLazyQueryHookResult = ReturnType<typeof useHrisIntegrationSidebarLazyQuery>;
export type HrisIntegrationSidebarQueryResult = Apollo.QueryResult<HrisIntegrationSidebarQuery, HrisIntegrationSidebarQueryVariables>;